import React from 'react'
import * as Yup from 'yup'
import { Form, Formik } from 'formik'
import { Credencials } from './AuthForm-types'
import { InputB } from '../../components/Input/InputB'
import { Button } from '../../components/Button'
import { CONTRIBUTOR_URL } from '../../constants/globalConstants'
import { useAuth } from './AuthForm-hooks'

export const AuthForm = () => {
  const {
    mutate: signin,
    isLoading,
    error,
  } = useAuth() as {
    mutate: (credentials: Credencials) => void
    isLoading: boolean
    error: Error
  }

  const initialValues = {
    username: '',
    password: '',
  }
  const validationSchema = Yup.object({
    username: Yup.string().required('Обязательно'),
    password: Yup.string().required('Обязательно'),
  })
  const onSubmit = async (values: Credencials) => {
    signin(values)
  }

  return (
    <div className='auth-module'>
      <h1 className='auth-module__title'>Войти</h1>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        validateOnBlur={false}
        validateOnChange={true}
        validateOnMount={true}
      >
        {(formik) => (
          <>
            <Form className='auth-module-form'>
              <InputB
                id='username'
                type='text'
                placeholder='Введите логин'
                className='auth-module-form__control'
                value={formik.values['username']}
                onChange={formik.handleChange}
              />
              <InputB
                id='password'
                type='password'
                placeholder='Введите пароль'
                className='auth-module-form__control'
                value={formik.values['password']}
                onChange={formik.handleChange}
              />
              <Button
                type='primary'
                htmlType='submit'
                className='auth-module-form__btn'
                loading={isLoading}
                fullSize
                disabled={!formik.isValid}
              >
                Войти в кабинет
              </Button>
              <a
                className='auth-module-form__link'
                href={`${CONTRIBUTOR_URL}/signin`}
                target='_blank'
                rel='noreferrer'
              >
                Войти как поставщик
              </a>
            </Form>
          </>
        )}
      </Formik>
      {error && (
        <span className='auth-module__error'>{error?.message || error}</span>
      )}
    </div>
  )
}

// pfQEaXfcB5Dk
